import { render, staticRenderFns } from "./qvyuplace.vue?vue&type=template&id=33536894&scoped=true&"
import script from "./qvyuplace.vue?vue&type=script&lang=js&"
export * from "./qvyuplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33536894",
  null
  
)

export default component.exports